<script setup>
import { inject } from 'vue';
import VButton from '../../../../components/buttons/VButton.vue';
// import useSetCartFromQuote from '../composables/useSetCartFromQuote';
import VIconSpinner from '../../../../icons/VIconSpinner.vue';

const props = defineProps({
  quoteId: {
    type: String,
    required: true,
  },
});

const trans = inject('translate');

// TODO add when we will add product from a shop
// const { setCartFromQuote, isLoading } = useSetCartFromQuote();

const handleClick = () => {
  window.location.href = `/my-order?quotes_number=${props.quoteId}`;
};

</script>

<template>
  <VButton
    :disabled="isLoading"
    @click="handleClick"
  >
    <VIconSpinner
      v-if="isLoading"
      class="animate-spin mx-1 h-4 w-4 spinner"
    />
    <span v-else>
      {{ trans.get('miliboo.customer.resume_quote') }}
    </span>
  </VButton>
</template>
